import React, { FunctionComponent, useState } from "react";
import { makeStyles } from "tss-react/mui";
import {
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Theme,
    Tooltip,
} from "@mui/material";
import MuiSelect from "@mui/material/Select";
import { useAppSelector } from "@/Redux/Redux";
import { RootStateOrAny, useSelector } from "react-redux";
import {
    selectViewerEnabledGroups,
    ViewerState,
} from "@/Redux/Auth/AuthReducer";
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface GroupFilterTabProps {
    predefinedFilter: any;
    setTmpFilter: any;
    setTmpCategoryFilter: any;
    selectedCategory: any;
    setSelectedCategory: any;
    groupsForFilter: any;
    getGroupsForFilter: any;
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    tabBar: {
        backgroundColor: "white",
    },

    checkboxAllLabel: {
        fontWeight: 700,
    },

    formControl: {
        width: "100%",
    },
}));

const GroupFilterTab: FunctionComponent<GroupFilterTabProps> = ({
    predefinedFilter,
    setTmpFilter,
    setTmpCategoryFilter,
    selectedCategory,
    setSelectedCategory,
    groupsForFilter,
    getGroupsForFilter,
                                                                    viewData
}): JSX.Element => {
    const { classes } = useStyles();
    const enabledGroups = useSelector((state) =>
        selectViewerEnabledGroups(state as ViewerState),
    );
    const groups = viewData?.vehicleGroupList?.vehicleGroups;

    const availableCategories = viewData?.categoryList?.categories;
    const { t } = useTranslation();

    const handleDropdownChange = (event: any) => {
        let selectedGroups = [];
        const tmpFilter = [];
        selectedGroups = getGroupsForFilter(event.target.value);
        for (const index in selectedGroups) {
            tmpFilter.push(selectedGroups[index].vehicleGroupId);
        }
        setTmpFilter(tmpFilter);
        setSelectedCategory(event.target.value);
        if (event.target.value !== "-1") {
            setTmpCategoryFilter([event.target.value]);
        } else {
            setTmpCategoryFilter([]);
        }
    };

    const handleCheckboxChange = (event: any) => {
        let tmpFilter = predefinedFilter.slice();
        if (event.target.checked) {
            if (event.target.value === "%") {
                tmpFilter = [];
                tmpFilter.push("%");
                for (const index in groupsForFilter) {
                    tmpFilter.push(groupsForFilter[index].vehicleGroupId);
                }
            } else {
                if (tmpFilter.indexOf("%") > -1) {
                    tmpFilter = [];
                }
                tmpFilter.push(event.target.value);
            }
            setTmpFilter(tmpFilter);
        } else {
            if (event.target.value === "%") {
                tmpFilter = [];
            } else {
                tmpFilter = tmpFilter.filter(function (
                    value: string,
                    index: number,
                    arr: any,
                ) {
                    return value !== event.target.value;
                });
            }
            setTmpFilter(tmpFilter);
        }
    };

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <FormControl
                    variant="outlined"
                    margin="dense"
                    className={classes.formControl}
                >
                    <InputLabel>{t("disposition.filter.carType")}</InputLabel>
                    <MuiSelect
                        size={"small"}
                        label={"Fzg. Art"}
                        onChange={handleDropdownChange}
                        value={selectedCategory}
                    >
                        <MenuItem value="-1">
                            <em>{t("disposition.filter.allCarTypes")}</em>
                        </MenuItem>
                        {availableCategories.map((item: any) => (
                            <MenuItem
                                key={item.categoryId}
                                value={item.categoryId}
                            >
                                {item.categoryId}
                            </MenuItem>
                        ))}
                    </MuiSelect>
                </FormControl>
            </Grid>
            <Grid item xs={12}>
                <Tooltip
                    title={t("disposition.controls.tooltip.selectAllGroups")}
                >
                    <Button
                        variant={"outlined"}
                        color={"secondary"}
                        size={"small"}
                        onClick={() => {
                            const tmpFilter = [];
                            let categoryIndex = "-1";
                            for (const index in availableCategories) {
                                const category = availableCategories[index];
                                if (category.categoryId === selectedCategory) {
                                    categoryIndex = index;
                                }
                            }
                            if (categoryIndex == "-1") {
                                for (const index in groupsForFilter) {
                                    tmpFilter.push(
                                        groupsForFilter[index].vehicleGroupId,
                                    );
                                }
                            } else {
                                const enabledGroupsInCategory =
                                    availableCategories[categoryIndex]
                                        ?.enabledVehicleGroups || [];
                                for (const idx in enabledGroupsInCategory) {
                                    tmpFilter.push(
                                        enabledGroupsInCategory[idx]
                                            .vehicleGroupId,
                                    );
                                }
                            }

                            setTmpFilter(tmpFilter);
                        }}
                    >
                        {t("disposition.controls.modal.selectAll")}
                    </Button>
                </Tooltip>{" "}
                <Tooltip
                    title={t("disposition.controls.tooltip.deselectAllGroups")}
                >
                    <Button
                        variant={"outlined"}
                        color={"secondary"}
                        size={"small"}
                        onClick={() => {
                            setTmpFilter([]);
                        }}
                    >
                        {t("disposition.controls.modal.deselectAll")}
                    </Button>
                </Tooltip>
            </Grid>
            {groupsForFilter.map((group: any) => (
                <Grid item key={group.vehicleGroupId} xs={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                size={"small"}
                                name="checkedB"
                                color="secondary"
                                value={group.vehicleGroupId}
                                onChange={handleCheckboxChange}
                                checked={
                                    predefinedFilter.indexOf(
                                        group.vehicleGroupId,
                                    ) > -1 &&
                                    predefinedFilter.indexOf("%") <= -1
                                }
                            />
                        }
                        label={group.vehicleGroupId + " - " + group.description}
                    />
                </Grid>
            ))}
        </Grid>
    );
};

export default GroupFilterTab;
